import React from 'react';
import { Box, Card, Typography } from '@material-ui/core';
import { useSelector } from 'react-redux';
import classNames from 'classnames';

import { ReturnRow } from 'types/ReturnTable';
import { useAppDispatch } from 'reducers';
import { PluginComponent } from 'plugins';
import { getProductCodeToShowOnReturnModal } from 'reducers/configs/settings';

import { toggleReturnRow } from '../../utils';
import {
  ProductName,
  ProductInfo,
  ProductQuantity,
  Checkbox,
  RowCardContent,
} from '../styled';

import AdditionalFields from './AdditionalFields';

type Props = {
  row: ReturnRow;
  globalReturnReason: string | undefined;
  depthLevel?: number;
};

const OrderProduct: React.FC<Props> = ({
  row,
  globalReturnReason,
  depthLevel = 1,
}) => {
  const dispatch = useAppDispatch();

  const codeToShow = useSelector(getProductCodeToShowOnReturnModal);

  const rowLocked = row.remainingAmount === 0 || !(row.isReturnable ?? true);

  return (
    <Card
      key={row.stableRowID}
      variant="outlined"
      data-testid="product-return-row"
    >
      <RowCardContent className={classNames({ rowLocked })}>
        <Box display="flex" alignItems="center">
          <PluginComponent
            hookname="UISingleReturnRowCheckbox"
            props={{
              row,
              rowLocked,
              isSelected: row.selected,
              globalReturnReason,
            }}
          >
            <Checkbox
              checked={row.selected ?? false}
              data-testid="product-row-toggle"
              onChange={e => {
                e.stopPropagation();
                dispatch(toggleReturnRow(row, globalReturnReason));
              }}
              invisible={rowLocked}
            />
          </PluginComponent>
          <ProductInfo depthLevel={depthLevel}>
            <ProductName
              variant="h6"
              depthLevel={depthLevel}
              data-testid="product-row-name"
            >
              {row.itemName}
            </ProductName>
            <Typography variant="body2" data-testid="product-row-barcode">
              {row[codeToShow]?.split(',').join(', ')}
            </Typography>
          </ProductInfo>
          <ProductQuantity>
            ×{' '}
            <span data-testid="product-row-original-qty">
              {row.originalAmount}
            </span>
          </ProductQuantity>
        </Box>
        <AdditionalFields row={row} />
      </RowCardContent>
      {row.children.map(ch => {
        return (
          <OrderProduct
            key={ch.stableRowID}
            row={ch}
            depthLevel={depthLevel + 1}
            globalReturnReason={globalReturnReason}
          />
        );
      })}
    </Card>
  );
};

export default OrderProduct;
